import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const Unauthorized = () => {
	const navigate = useNavigate();
	return (
		<>
			<SEO 
				title="Access Denied - Unauthorized | ReferMe"
				description="You do not have permission to access this page."
				noindex={true}
			/>
			<div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-950 to-gray-900 text-white">
			<div className="max-w-3xl w-full p-8 bg-gray-900/60 border border-gray-800 rounded-2xl shadow-lg text-center">
				<h1 className="text-4xl font-extrabold mb-3">Access unavailable</h1>
				<p className="text-gray-300 mb-6">You tried to reach a page that isn't available to you, or the address doesn't exist.</p>

				<div className="flex flex-col sm:flex-row gap-3 justify-center">
					<button onClick={() => navigate(-1)} className="px-5 py-2 rounded-xl bg-gray-800 border border-gray-700 text-gray-200">Go back</button>
					<Link to="/" className="px-5 py-2 rounded-xl bg-indigo-600 text-white">Home</Link>
					<Link to="/support" className="px-5 py-2 rounded-xl border border-gray-700 text-gray-200">Contact support</Link>
				</div>

				<div className="mt-6 text-sm text-gray-400">
					If you think this is a mistake, make sure you're logged in with the right account or contact support.
				</div>
			</div>
		</div>
		</>
	);
};

export default Unauthorized;
